import "./index.scss";
import React from "react";
import NewDaysList from "./components/new-days-list";

export default function WorkoutDays() {
    return <NewDaysList />;
}